// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__21dGB","icon":"SortAdornment_icon__3-GKg","up":"SortAdornment_up__2rUdr","down":"SortAdornment_down__2Sxas","active":"SortAdornment_active__py0zy"};